import {
  SYSTEM_PARAM_CATEGORY_HEADER_TONE_KEYS,
  SYSTEM_PARAM_CATEGORY_HEADER_TONES,
  SYSTEM_PARAM_CATEGORY_KEYS,
  TSystemParamCategoryKey,
} from "./system-params.category.constants";
import {
  ISystemParamCategoryHeaderColors,
  TSystemParamCategoryTone,
} from "./system-params.category.models";

const buildHeaderColors = ({
  bg,
  text,
  border,
}: TSystemParamCategoryTone): ISystemParamCategoryHeaderColors => ({
  backgroundColor: bg,
  color: text,
  boxShadow: `inset 0 0 0 1px ${border}`,
});

export const normalizeSystemParamCategoryKey = (
  label?: string,
): TSystemParamCategoryKey => {
  const normalized = (label ?? SYSTEM_PARAM_CATEGORY_KEYS.general)
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");

  if (normalized in SYSTEM_PARAM_CATEGORY_HEADER_TONES) {
    return normalized as TSystemParamCategoryKey;
  }

  return SYSTEM_PARAM_CATEGORY_HEADER_TONE_KEYS[
    Math.abs(normalized.charCodeAt(0) || 0) %
      SYSTEM_PARAM_CATEGORY_HEADER_TONE_KEYS.length
  ];
};

export const getSystemParamCategoryHeaderColors = (
  label?: string,
): ISystemParamCategoryHeaderColors => {
  const categoryKey = normalizeSystemParamCategoryKey(label);
  const tone = SYSTEM_PARAM_CATEGORY_HEADER_TONES[categoryKey];

  return buildHeaderColors(tone);
};
